/**
 * アプリ内ブラウザ（WebView）の検出
 *
 * LINE, Facebook, Instagram, Twitter/X などのアプリ内ブラウザでは
 * GoogleのOAuth認証がセキュリティポリシーによりブロックされるため、
 * 事前に検出してユーザーに外部ブラウザでの利用を案内する
 */
export function detectInAppBrowser() {
  const ua = navigator.userAgent || '';

  if (/\bLine\//i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'line', displayName: 'LINE' };
  }

  if (/\bFBAN\b/i.test(ua) || /\bFBAV\b/i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'facebook', displayName: 'Facebook' };
  }

  if (/\bInstagram\b/i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'instagram', displayName: 'Instagram' };
  }

  if (/\bTwitter\b/i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'twitter', displayName: 'X (Twitter)' };
  }

  if (/\bTikTok\b/i.test(ua) || /\bBytedance\b/i.test(ua)) {
    return { isInAppBrowser: true, browserType: 'tiktok', displayName: 'TikTok' };
  }

  const isAndroidWebView = /\bwv\b/.test(ua) && /\bAndroid\b/i.test(ua);
  const isIOSWebView = /\bAppleWebKit\b/i.test(ua) && /\biPhone|iPad|iPod\b/i.test(ua) && !/\bSafari\b/i.test(ua);

  if (isAndroidWebView || isIOSWebView) {
    return { isInAppBrowser: true, browserType: 'other-webview', displayName: null };
  }

  return { isInAppBrowser: false, browserType: null, displayName: null };
}
